export enum Breakpoint {
    fromSmallDesktop = "min-width: 992px",
    untilSmallDesktop = "max-width: 991px",
    untilLargeMobile = "max-width: 575px",
    untilLargeDesktop = "max-width: 1200px",
    mobile = "max-width: 767px",
    smallMobile = "max-width: 415px",

    mediumDesktop = "max-height: 900px",
    smallDesktop = "max-height: 820px",
    extraSmallDesktop = "max-height: 680px",
}
